import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Check, Lock, Zap, ShieldCheck, Download, Sparkles } from 'lucide-react';
interface ExitUpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
  currentCartUrl: string;
}
export function ExitUpsellPopup({
  isOpen,
  onClose,
  currentCartUrl
}: ExitUpsellPopupProps) {
  const handleAccept = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Freelance desde Cero (Bundle Completo 30% OFF)',
        content_type: 'product',
        value: 22.4,
        currency: 'USD'
      });
    }
    window.location.href = 'https://coresolutionsg.com/cart/47554883911867:1';
  };
  const handleDecline = () => {
    window.location.href = currentCartUrl;
  };
  return <AnimatePresence data-id="element-18">
      {isOpen && <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6" data-id="element-19">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-20" />

          {/* Popup Container */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-lg bg-[#faf6f1] rounded-2xl shadow-2xl border border-[#b8956a]/30 overflow-hidden max-h-[90vh] flex flex-col" data-id="element-21">
            {/* Close Button */}
            <button onClick={onClose} className="absolute top-3 right-3 z-10 p-2 text-white/80 hover:text-white bg-black/20 hover:bg-black/40 rounded-full transition-colors" aria-label="Cerrar" data-id="element-22">
              <X className="w-5 h-5" data-id="element-23" />
            </button>

            {/* Header Banner */}
            <div className="bg-gradient-to-r from-[#3d2b1f] to-[#5a3f2e] pt-5 pb-4 px-5 md:pt-8 md:pb-6 md:px-8 text-center relative overflow-hidden" data-id="element-24">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#c47a6a] via-[#e0bfb4] to-[#c47a6a]" data-id="element-25" />

              <div className="inline-flex items-center gap-1.5 bg-[#c47a6a]/20 border border-[#c47a6a]/40 text-[#ffb5a7] text-[10px] font-bold px-3 py-1 rounded-full tracking-wider uppercase mb-2 md:mb-4" data-id="element-26">
                <Zap className="w-3 h-3" data-id="element-27" />
                30% OFF — SOLO AQUÍ
              </div>

              <h2 className="text-xl md:text-3xl font-extrabold text-white leading-tight" data-id="element-28">
                No empieces sin esto
              </h2>
            </div>

            {/* Body */}
            <div className="p-4 md:p-8 overflow-y-auto" data-id="element-29">
              {/* What you already have */}
              <p className="text-xs text-[#6b5744] font-medium text-center mb-2" data-id="element-30">
                Ya tienes la guía + 6 bonos. ¿Quieres agregar esto?
              </p>

              {/* The 2 optional extras */}
              <div className="bg-[#3d2b1f]/5 rounded-xl p-3 md:p-4 mb-3 md:mb-4 border border-[#e0bfb4]/40" data-id="element-31">
                <p className="text-[10px] font-bold text-[#b8956a] uppercase tracking-wider mb-1.5" data-id="element-32">
                  ⚡ 2 extras opcionales
                </p>
                <div className="space-y-1.5" data-id="element-33">
                  <div className="flex items-start gap-2" data-id="element-34">
                    <Check className="w-3.5 h-3.5 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-35" />
                    <span className="text-sm text-[#3d2b1f] font-bold" data-id="element-36">
                      Scripts de Poder — guiones para cerrar clientes por
                      WhatsApp
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-37">
                    <Check className="w-3.5 h-3.5 text-[#7a9a6b] flex-shrink-0 mt-0.5" data-id="element-38" />
                    <span className="text-sm text-[#3d2b1f] font-bold" data-id="element-39">
                      Contrato Relámpago — editable para proteger tus pagos
                    </span>
                  </div>
                </div>
              </div>

              {/* Pricing Block */}
              <div className="text-center mb-3 md:mb-4" data-id="element-40">
                <p className="text-[10px] text-[#6b5744] font-medium mb-1" data-id="element-41">
                  Todo junto (guía + bonos + extras):
                </p>
                <div className="flex items-center justify-center gap-3 mb-0.5" data-id="element-42">
                  <span className="text-[#9a8b7a] line-through text-base font-medium" data-id="element-43">
                    $32
                  </span>
                  <span className="text-3xl md:text-4xl font-extrabold text-[#b8956a]" data-id="element-44">
                    $22.40 <span className="text-lg text-[#6b5744]" data-id="element-45">USD</span>
                  </span>
                </div>
                <p className="text-xs text-[#7a9a6b] font-bold" data-id="element-46">
                  Ahorras $9.60
                </p>
              </div>

              {/* Trust Badges — single line on mobile */}
              <div className="flex items-center justify-center gap-3 text-[10px] md:text-sm text-[#6b5744] font-medium mb-3 md:mb-5" data-id="element-47">
                <span className="flex items-center gap-1" data-id="element-48">
                  <Lock className="w-3 h-3 text-[#7a9a6b]" data-id="element-49" />
                  Seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-50">
                  <Download className="w-3 h-3 text-[#7a9a6b]" data-id="element-51" />
                  Inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-52">
                  <ShieldCheck className="w-3 h-3 text-[#7a9a6b]" data-id="element-53" />
                  Garantía 7d
                </span>
              </div>

              {/* CTA */}
              <button onClick={handleAccept} className="w-full py-3.5 md:py-4 px-6 bg-[#7a9a6b] hover:bg-[#68855a] text-white font-bold text-sm md:text-lg rounded-full shadow-lg transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2 relative overflow-hidden group" data-id="element-54">
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-55" />
                <span className="relative z-10" data-id="element-56">
                  SÍ, QUIERO TODO POR $22.40
                </span>
              </button>

              {/* Decline — more visible */}
              <button onClick={handleDecline} className="mt-3 md:mt-4 w-full py-2.5 text-[13px] md:text-sm text-[#6b5744] font-semibold border border-[#d4b896]/60 rounded-full hover:bg-[#3d2b1f]/5 transition-colors text-center" data-id="element-57">
                No gracias, solo quiero la guía por $14 →
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}